// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2mCN9","buttons":"SendReceipts_buttons__-jAg5","email":"SendReceipts_email__gdEX6","bookApptTitle":"SendReceipts_bookApptTitle__10DOn"};